import { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Download, Upload } from '@mui/icons-material';

import Button from 'components/Button/Button';
import Typography from 'components/Typography/Typography';

type HeaderProps = {
    onAddPricePoint: () => void;
    onImport: () => void;
    onExport: () => void;
    isExportDisabled: boolean;
    isManageDisabled: boolean;
};

const Header: FC<HeaderProps> = ({
    onAddPricePoint,
    onImport,
    onExport,
    isExportDisabled,
    isManageDisabled
}) => {
    return (
        <div className="pt-8 mb-5" data-testid="PricingHeader">
            <div className="flex justify-between items-center min-h-10">
                <div className="flex flex-col gap-1">
                    <Typography className="text-hd-h3">Pricing</Typography>
                </div>
                <div className="flex items-center gap-2.5">
                    <Button
                        data-testid="PricingHeader-ImportButton"
                        onClick={onImport}
                        variant="outline"
                        leftIcon={<FontAwesomeIcon icon="fa-regular fa-arrow-up-from-line" />}
                        disabled={isManageDisabled}
                    >
                        Import
                    </Button>
                    <Button
                        data-testid="PricingHeader-ExportButton"
                        onClick={onExport}
                        leftIcon={<FontAwesomeIcon icon="fa-regular fa-arrow-down-to-line" />}
                        variant="outline"
                        disabled={isExportDisabled || isManageDisabled}
                    >
                        Export
                    </Button>
                    <Button
                        data-testid="PricingHeader-PrimaryButton"
                        onClick={onAddPricePoint}
                        isCreateButton
                        disabled={isManageDisabled}
                    >
                        Add new price point
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Header;

